<template>
    <v-data-table
        :headers="headers"
        :items="TIMEENTRY_GET"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
        loading="true"
    >
        <template slot="items" slot-scope="props">
            <td><v-icon v-if="(props.item.timestamp + 48 * 3600) > (Date.now() / 1000)"
              small
              class="mr-2"
              @click="editEntry(props.item.id)"
            >
              edit
            </v-icon></td>
            <td>{{ props.item.date }}</td>
            <td>{{ props.item.duration }}</td>
            <td>{{ (typeof props.item.customer === 'object') ? props.item.customer.name : props.item.customer }}</td>
            <td>{{ props.item.project }}</td>
            <td>{{ props.item.position }}</td>
            <td>{{ props.item.qty }} {{ props.item.unity }}</td>
        </template>
        <template slot="no-data">
            <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { TIMEENTRY_GET, TIMEENTRY_INDEX } from '../../store/actions/timeEntry'
import { SALESLINES_GET } from '../../store/actions/salesOrder'
export default {
  data () {
    return {
      headers: [
        {
          text: '#',
          sortable: false
        },
        {
          text: 'Datum',
          align: 'left',
          value: 'timestamp'
        },
        {
          text: 'Dauer',
          value: 'duration',
          sortable: false
        },
        {
          text: 'Kunde',
          value: 'customer'
        },
        {
          text: 'Auftrag',
          value: 'project'
        },
        {
          text: 'Position',
          value: 'position'
        },
        {
          text: 'Menge',
          value: 'qty'
        }
      ],
      pagination: {
        sortBy: 'timestamp',
        descending: true,
        rowsPerPage: 25
      }
    }
  },
  computed: {
    ...mapGetters([
      TIMEENTRY_GET, SALESLINES_GET
    ])
  },
  mounted () {
    this.$store.dispatch(TIMEENTRY_INDEX)
  },
  methods: {
    editEntry (lineId) {
      this.$store.dispatch(TIMEENTRY_GET, lineId).then(resp => {
        this.$router.push({name: 'timeentry', params: { edit: resp }})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/History/Index.vue